import { useForm } from "react-hook-form";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import useFormHook from '@shared/hooks/useFormHook';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';

export default function CurrencyForm({ onClose, onConfirm, editData, formProps }) {
    const { t } = useTranslation();
    const { modalRef } = useFormHook({}, onClose);

    const validationSchema = yup.object().shape({
        codeIso: yup.string().required(t('common.required')),
        mnemonic: yup.string().required(t('common.required')),
        description: yup.string().required(t('common.required')),
    });

    const { register, handleSubmit, reset, formState: { errors } } = useForm({
        ...formProps,
        resolver: yupResolver(validationSchema),
        mode: 'onChange',
        reValidateMode: 'onChange',
        criteriaMode: 'all',
        defaultValues: editData ? {
            codeIso: editData.codeIso,
            mnemonic: editData.mnemonic,
            description: editData.description,
            active: editData.active
        } : {
            codeIso: '',
            mnemonic: '',
            description: '',
            active: true
        }
    });

    useEffect(() => {
        if (editData) {
            reset({
                codeIso: editData.codeIso,
                mnemonic: editData.mnemonic,
                description: editData.description,
                active: editData.active
            });
        }
    }, [editData, reset]);

    const submitForm = async (data) => {
        if (onConfirm) {
            await onConfirm(data);
        }
    }

    return (
        <div className="modal show" tabIndex="-1">
            <div className="modal-dialog modal-confirm" ref={modalRef}>
                <div className="modal-content">
                    <button type="button" className="close" onClick={onClose}>
                        <FontAwesomeIcon icon={faTimes} />
                    </button>
                    <div className="modal-body">
                        <h4 className="modal-title">
                            {editData ? t('common.edit') : t('common.add')} {t('payments.currencies.title')}
                        </h4>
                        <form id="currencyForm" className="region-form" onSubmit={handleSubmit(submitForm)}>
                            <div className="form-sections">
                                <div className="form-section">
                                    <div className="form-group">
                                        <span className="span-bold"> {t('payments.currencies.form.digitalCode')}:  <span className="required">*</span></span>
                                        <input
                                            type="text"
                                            className="form-control"
                                            {...register('codeIso', { required: true })}
                                            maxLength={3}

                                        />
                                        {errors.codeIso && <p className="text-danger">{errors.codeIso.message}</p>}
                                    </div>

                                    <div className="form-group">
                                        <span className="span-bold"> {t('payments.currencies.form.code')}:  <span className="required">*</span></span>
                                        <input
                                            type="text"
                                            className="form-control"
                                            {...register('mnemonic', { required: true })}
                                            maxLength={3}
                                        />
                                        {errors.mnemonic && <p className="text-danger">{errors.mnemonic.message}</p>}
                                    </div>

                                    <div className="form-group">
                                        <span className="span-bold"> {t('payments.currencies.form.currency')}:  <span className="required">*</span></span>
                                        <input
                                            type="text"
                                            className="form-control"
                                            {...register('description', { required: true })}
                                        />
                                        {errors.description && <p className="text-danger">{errors.description.message}</p>}
                                    </div>

                                    <div className="form-group">
                                        <span className="span-bold"> {t('payments.currencies.form.active')}:</span>
                                        <div className="checkbox-wrapper-start title-checkbox">
                                            <input
                                                type="checkbox"
                                                id="active"
                                                {...register('active')}
                                            />
                                            <label htmlFor="active"> {t('payments.currencies.form.active')}</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                    <div className="modal-footer">
                        <button type="submit" form="currencyForm" className="btn btn-primary">
                            {t('common.save')}
                        </button>
                        <button type="button" className="btn btn-secondary" onClick={onClose}>
                            {t('common.cancel')}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}
